import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/Users/jarl/Documents/Projects/civitas/kenobi/docs/node_modules/gatsby-theme-docz/src/base/Layout.js";
import { Playground, Props } from 'docz';
import { Drawer, Button, Heading } from 'kenobi-ui';
import Component from '@reach/component-component';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h1 {...{
      "id": "drawer"
    }}>{`Drawer`}</h1>
    <h3 {...{
      "id": "accessible-dialogmodal"
    }}>{`Accessible Dialog/Modal.`}</h3>
    <h3 {...{
      "id": "drawer-is-a-component-that-shows-up-on-either-the-right-or-left-side-of-the-page-overlaying-any-content"
    }}><inlineCode parentName="h3">{`Drawer`}</inlineCode>{` is a component that shows up on either the `}<inlineCode parentName="h3">{`right`}</inlineCode>{` or `}<inlineCode parentName="h3">{`left`}</inlineCode>{` side of the page overlaying any content.`}</h3>
    <h3 {...{
      "id": "the-close-icon-contains-a-visually-hidden-element-this-provides-a-text-version-of-the-icon-to-screen-readers"
    }}>{`The close icon contains a `}<inlineCode parentName="h3">{`Visually Hidden`}</inlineCode>{` element. This provides a text version of the icon to screen readers.`}</h3>
    <h2 {...{
      "id": "usage"
    }}>{`Usage`}</h2>
    <Playground __position={0} __code={'<Component initialState={{ isOpen: false }}>\n  {({ setState, state }) => (\n    <React.Fragment>\n      <Drawer\n        isOpen={state.isOpen}\n        width={350}\n        onRequestClose={() => setState({ isOpen: false })}\n      >\n        <Heading size={600}>Drawer Title</Heading>\n      </Drawer>\n      <Button onClick={() => setState({ isOpen: true })}>Show</Button>\n    </React.Fragment>\n  )}\n</Component>'} __scope={{
      props,
      DefaultLayout,
      Playground,
      Props,
      Drawer,
      Button,
      Heading,
      Component
    }} mdxType="Playground">
  <Component initialState={{
        isOpen: false
      }} mdxType="Component">
    {({
          setState,
          state
        }) => <React.Fragment>
        <Drawer isOpen={state.isOpen} width={350} onRequestClose={() => setState({
            isOpen: false
          })} mdxType="Drawer">
          <Heading size={600} mdxType="Heading">Drawer Title</Heading>
        </Drawer>
        <Button onClick={() => setState({
            isOpen: true
          })} mdxType="Button">Show</Button>
      </React.Fragment>}
  </Component>
    </Playground>
    <h2 {...{
      "id": "focusing"
    }}>{`Focusing`}</h2>
    <h3 {...{
      "id": "by-default-the-close-icon-is-always-focused-on-opening"
    }}>{`By default the close icon is always focused on opening.`}</h3>
    <h3 {...{
      "id": "if-you-want-another-element-to-be-focused-on-opening-you-can-specify-data-autofocus-on-the-element"
    }}>{`If you want another element to be focused on opening, you can specify `}<inlineCode parentName="h3">{`data-autofocus`}</inlineCode>{` on the element.`}</h3>
    <Playground __position={1} __code={'<Component initialState={{ isOpen: false }}>\n  {({ setState, state }) => (\n    <React.Fragment>\n      <Drawer\n        isOpen={state.isOpen}\n        width={350}\n        onRequestClose={() => setState({ isOpen: false })}\n      >\n        <Button data-autofocus>Focused button</Button>\n      </Drawer>\n      <Button onClick={() => setState({ isOpen: true })}>Show</Button>\n    </React.Fragment>\n  )}\n</Component>'} __scope={{
      props,
      DefaultLayout,
      Playground,
      Props,
      Drawer,
      Button,
      Heading,
      Component
    }} mdxType="Playground">
  <Component initialState={{
        isOpen: false
      }} mdxType="Component">
    {({
          setState,
          state
        }) => <React.Fragment>
        <Drawer isOpen={state.isOpen} width={350} onRequestClose={() => setState({
            isOpen: false
          })} mdxType="Drawer">
          <Button data-autofocus mdxType="Button">Focused button</Button>
        </Drawer>
        <Button onClick={() => setState({
            isOpen: true
          })} mdxType="Button">Show</Button>
      </React.Fragment>}
  </Component>
    </Playground>
    <h2 {...{
      "id": "props"
    }}>{`Props`}</h2>
    <Props of={Drawer} mdxType="Props" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      